import React from 'react';
import { 
  BuildingOfficeIcon,
  PhoneIcon,
  EnvelopeIcon,
  GlobeAltIcon
} from '@heroicons/react/24/outline';

const Footer = ({ variant = 'default' }) => {
  const currentYear = new Date().getFullYear();

  if (variant === 'minimal') {
    return (
      <footer className="bg-white border-t border-gray-200 py-4">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-3 items-center">
            {/* Neoflux a sinistra */}
            <div className="flex items-center text-sm text-gray-500 justify-start">
              Powered by
              <a 
                href="https://neoflux.it" 
                target="_blank" 
                rel="noopener noreferrer"
                className="ml-2 hover:opacity-80 transition-opacity"
              >
                <img 
                  src="https://neoflux.it/logo-neoflux.png" 
                  alt="Neoflux" 
                  className="h-6 w-auto"
                />
              </a>
            </div>
            
            {/* Copyright perfettamente centrato */}
            <div className="text-sm text-gray-500 text-center">
              © {currentYear} WAPOO.it - Tutti i diritti riservati.
            </div>
            
            {/* Spazio vuoto a destra per bilanciare */}
            <div></div>
          </div>
        </div>
      </footer>
    );
  }

  return (
    <footer className="bg-gray-50 border-t border-gray-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="grid grid-cols-3 items-center">
          {/* Neoflux a sinistra */}
          <div className="flex items-center text-sm text-gray-500 justify-start">
            Powered by
            <a 
              href="https://neoflux.it" 
              target="_blank" 
              rel="noopener noreferrer"
              className="ml-2 hover:opacity-80 transition-opacity"
            >
              <img 
                src="https://neoflux.it/logo-neoflux.png" 
                alt="Neoflux" 
                className="h-6 w-auto"
              />
            </a>
          </div>
          
          {/* Copyright perfettamente centrato */}
          <div className="text-sm text-gray-500 text-center">
            © {currentYear} WAPOO.it - Tutti i diritti riservati.
          </div>
          
          {/* Links a destra */}
          <div className="flex space-x-6 items-center justify-end">
            <a href="/nlt/privacy" className="text-sm text-gray-500 hover:text-blue-600 transition-colors">
              Privacy Policy
            </a>
            <a href="/nlt/termini" className="text-sm text-gray-500 hover:text-blue-600 transition-colors">
              Termini di Servizio
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 